import React from "react";
import ReactDOM from "react-dom/client";
import './index.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AboutUS from "./component/About-us/AboutUs";
import Home from "./component/Home/Home";
import HomeDefault from "./component/Home/HomeDefault";
import MemberTeam from "./component/Member-Team/MemberTeam";
import Recruitment from "./component/Recruitment/views/Recruitment";
import RecruitmentDetail from "./component/Recruitment/views/recruitment-detail";
import LibraryImage from "./component/Library-Image/LibraryImage";
import ContactUs from "./component/Contact-Us/ContactUs";
import BusinessPartner from "./component/Business-Partner/BusinessPartner";
import Productss from "./component/Productss/Productss";
import TimeNew from "./component/Time-New/TimeNew";
import NewDetail from "./component/New-Detail/NewDetail";
import ChinhSach from "./component/chinh-sach/chinh-sach-bao-mat";
import DieuKhoan from "./component/dieu-khoan/dieu-khoan-dich-vu";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<HomeDefault />} />
          <Route path="aboutus" element={<AboutUS />} />
          <Route path="recruitment" element={<Recruitment />}></Route>
          <Route
            path="recruitment/detail/:slug/:id"
            element={<RecruitmentDetail />}
          />
          <Route path="member-team" element={<MemberTeam />} />
          <Route path="" element={<HomeDefault />}></Route>
          <Route path="aboutus" element={<AboutUS />}></Route>
          <Route path="member-team" element={<MemberTeam />}></Route>
          <Route path="library" element={<LibraryImage />}></Route>
          <Route path="contact-us" element={<ContactUs />}></Route>
          <Route path="bussiness-part" element={<BusinessPartner />}></Route>
          <Route path="produ" element={<Productss />}></Route>
          <Route path="time-new" element={<TimeNew />}></Route>
          <Route path="new-detail" element={<NewDetail />}></Route>
          <Route path="chinh-sach-bao-mat" element={<ChinhSach />}></Route>
          <Route path="dieu-khoan-su-dung" element={<DieuKhoan />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
